// NOTE: This is part of the lower level of the New Computation Model, and
// should be kept isolated from non-trivial Glide dependencies.  In
// particular, it shouldn't have to know anything about Glide table/column
// types/schemas.

import type { PathForColumn } from "../common/components/types";
import type { Path, RootPath, ValueAndFormatPaths } from "../common/computation-model/paths";
import { makeKeyPath } from "../common/computation-model/paths";

export function makeValueAndFormatPaths(
    columnName: string,
    valueInfo: PathForColumn | undefined,
    formatInfo: PathForColumn | undefined,
    baseRootPath: RootPath | undefined
): ValueAndFormatPaths {
    const valueRootPath = valueInfo?.rootPath ?? baseRootPath;
    let valuePath: Path;
    if (valueInfo !== undefined) {
        valuePath = valueInfo.isGlobal ? valueInfo.rootPath : valueInfo.columnPath;
    } else {
        valuePath = makeKeyPath(columnName);
    }

    const formatRootPath = formatInfo?.rootPath;
    let formatPath: Path | undefined;
    if (formatInfo !== undefined) {
        formatPath = formatInfo.isGlobal ? formatInfo.rootPath : formatInfo.columnPath;
    } else {
        formatPath = undefined;
    }

    return [
        [valuePath, valueRootPath],
        [formatPath, formatRootPath],
    ];
}
